module.exports = __webpack_public_path__ + "img/step31_a_remove packaging.404306e0.png";